import axios from "axios";
import config from "@/config";
import store from "../store";
import tokenAuth from "./tokenAuthenticationService";
import router from "../router";

const apiEndPoint = axios.create({
  baseURL: config.API_ENDPOINT,
  json: true,
});
const telematicsEndPoint = axios.create({
  baseURL: config.TELEMATICS_ENDPOINT,
  json: true,
});
const alertconfigEndpoint = axios.create({
  baseURL: config.ALERT_CONFIG_ENDPOINT,
  json: true,
});
const smsEndPoint = axios.create({
  baseURL: config.SMS_ENDPOINT,
  json: true,
});
const smsEndPointNew = axios.create({
  baseURL: config.SMS_ENDPOINT_NEW,
  json: true,
});
const locationEndpoint = axios.create({
  baseURL: config.LOCATION_ENDPOINT,
  json: true,
});
function interceptorRequest(config) {
  const token = store.getters.token;
  // if (
  //   tokenAuth.accessTokenValidation(token, store.getters.tokenExpiryTime)
  // ) {
  config.headers.Authorization = `Bearer ${token}`;
  return config;
  // } else {
  //   return config;
  // }
}
function interceptorResponse(error) {
  var refershObject = {
    grant_type: "refresh_token",
    refresh_token: store.getters.refreshToken,
    user_name: store.getters.user,
  };
  //   store.commit("updateisTokenRefreshing", true);
  tokenAuth.getAccessTokenByRefreshToken(
    refershObject,
    (response) => {
      store.commit("SET_ACCESS_TOKEN", response.access_token);
      store.commit("SET_REFRESH_TOKEN", response.refresh_token);
      store.commit("SET_TOKEN_EXPIRY_TIME", response.expires_at);
      //   store.commit("updateisTokenRefreshing", false);
      if (error.config.url) {
        error.config.headers.Authorization = `Bearer ${response.access_token}`;
        return axios.request(error.config);
      }
    },
    (errorResponse) => {
      console.log(errorResponse);
      store.dispatch("LogOut");
      router.push("/signin");
    }
  );
}

apiEndPoint.interceptors.request.use(
  function (config) {
    let finalConfig = interceptorRequest(config);
    return finalConfig;
  },
  function (err) {
    return Promise.reject(err);
  }
);
telematicsEndPoint.interceptors.request.use(
  function (config) {
    let finalConfig = interceptorRequest(config);
    return finalConfig;
  },
  function (err) {
    return Promise.reject(err);
  }
);
alertconfigEndpoint.interceptors.request.use(
  function (config) {
    let finalConfig = interceptorRequest(config);
    return finalConfig;
  },
  function (err) {
    return Promise.reject(err);
  }
);

smsEndPointNew.interceptors.request.use(
  function (config) {
    let finalConfig = interceptorRequest(config);
    return finalConfig;
  },
  function (err) {
    return Promise.reject(err);
  }
);
apiEndPoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});

smsEndPoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});
smsEndPointNew.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});
telematicsEndPoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});
alertconfigEndpoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});

locationEndpoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});
locationEndpoint.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    interceptorResponse(error);
  }
  return Promise.reject(error);
});
export default {
  apiEndPoint,
  telematicsEndPoint,
  alertconfigEndpoint,
  smsEndPoint,
  smsEndPointNew,
  locationEndpoint,
};
